"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgBonusTemplateCustomZoneEditorCtl = /** @class */ (function (_super) {
    __extends(DlgBonusTemplateCustomZoneEditorCtl, _super);
    function DlgBonusTemplateCustomZoneEditorCtl() {
        return _super.call(this, true) || this;
    }
    DlgBonusTemplateCustomZoneEditorCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            statusVal: 0,
            statusesAvail: [],
            zoneVal: 0,
            zonesAvail: [],
            onNo: null
        };
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetStatuses = function (bets, forceUpdate) {
        this.DATA.statusesAvail = bets;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetStatuses = function () {
        return this.DATA.statusesAvail;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetStatusVal = function (Val, forceUpdate) {
        this.DATA.statusVal = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetStatusVal = function () {
        return this.DATA.statusVal;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetZones = function (zones, forceUpdate) {
        this.DATA.zonesAvail = zones;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetZones = function () {
        return this.DATA.zonesAvail;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.SetZoneVal = function (Val, forceUpdate) {
        this.DATA.zoneVal = Val;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgBonusTemplateCustomZoneEditorCtl.prototype.GetZoneVal = function () {
        return this.DATA.zoneVal;
    };
    return DlgBonusTemplateCustomZoneEditorCtl;
}(BaseController_1.BaseController));
exports.DlgBonusTemplateCustomZoneEditorCtl = DlgBonusTemplateCustomZoneEditorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgBonusTemplateCustomZoneEditorCtl.ts
// module id = 915
// module chunks = 0